import { createSlice } from '@reduxjs/toolkit';

const initialState: { [key: string]: boolean } = {};

const guiaDigitalBloquesIsDirtyStateSlice = createSlice({
	name: 'guiaDigitalBloquesIsDirtyState',
	initialState,
	reducers: {
		setGuiaDigitalBloquesIsDirtyState: (state, action) => {
			return action.payload;
		},
		updateGuiaDigitalBloquesIsDirtyState: (state, action) => {
			return { ...state, ...action.payload };
		},
		resetGuiaDigitalBloquesIsDirtyState: () => initialState
	}
});

export const {
	setGuiaDigitalBloquesIsDirtyState,
	resetGuiaDigitalBloquesIsDirtyState,
	updateGuiaDigitalBloquesIsDirtyState
} = guiaDigitalBloquesIsDirtyStateSlice.actions;
export default guiaDigitalBloquesIsDirtyStateSlice.reducer;
